export function SectionHeading({ eyebrow, title, description, testIdPrefix }) {
  return (
    <div className="max-w-3xl space-y-4" data-testid={`${testIdPrefix}-wrapper`}>
      <p className="text-sm font-semibold uppercase tracking-[0.28em] text-primary" data-testid={`${testIdPrefix}-eyebrow`}>
        {eyebrow}
      </p>
      <h2 className="text-4xl font-bold text-foreground md:text-5xl" data-testid={`${testIdPrefix}-title`}>
        {title}
      </h2>
      <p className="max-w-2xl text-sm text-muted-foreground md:text-base" data-testid={`${testIdPrefix}-description`}>
        {description}
      </p>
    </div>
  );
}